import { render, staticRenderFns } from "./ReportExtras.vue?vue&type=template&id=bb619de2&"
import script from "./ReportExtras.vue?vue&type=script&lang=ts&"
export * from "./ReportExtras.vue?vue&type=script&lang=ts&"
import style0 from "./ReportExtras.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSimpleTable})
